import React from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CustomReactPlayer from "../../CustomReactPlayer";

export const FixingAttachments = () => {
  const { t: _t } = useTranslation();
  return (
    <>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/0.jpg")} effect="blur" alt="" />
      <h2>{_t("Описание методики:")}</h2>
      <p>
        {_t(
          "Активатор (аттачмент) – ретенционные пункты на зубах, выполненные из композитного материала, предназначенные для более качественного передвижения зубов элайнерами. Данный протокол содержит рекомендации по фиксации активаторов (аттачметов) на зубах с использованием специального шаблона в виде капы с нулевым передвижением зубов для фиксации активаторов. Для реализации данного протокола необходимо использовать специальное устройство, которое обозначается в системе, как «Шаблон для фиксации активаторов». Он изготавливается по модели без передвижения зубов, но с расставленными активаторами соответствующей формы. Материал, из которого изготавливается шаблон должен быть более эластичным чем элайнеры, и не соединяется химически с композитным фотополимером. Эти свойства обеспечивают беспрепятственное извлечение устройства из полости рта после фиксации ретенционных пунктов. В данном случае изделие выступает в роли пресс-формы для создания активаторов и может выполнять повторную функцию в случае сколов аттачметов в процессе, а также на любых этапах ортодонтического лечения элайнерами.",
        )}
      </p>
      <CustomReactPlayer
        src={require("../../assets/2_fixing-attachments/video_1.mp4")}
        poster={require("../../assets/2_fixing-attachments/video_1.jpg")}
      />

      <h2>{_t("Классификация активаторов по системе TranspaDent.")}</h2>
      <p>
        {_t(
          "Предусмотрено несколько типов активаторов разной формы. Каждый тип активатора имеет своё предназначение и используется в определённых случаях, предусмотренных протоколами лечения.",
        )}
      </p>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/1.jpg")} effect="blur" alt="" />
      <h2>{_t("Протокол фиксации активаторов:")}</h2>
      <p>
        {_t(
          "Для фиксации активаторов на зубах в соответствии с проектом ортодонтического лечения элайнерами необходимо применить протокол:",
        )}
      </p>
      <p>{_t("– извлечь шаблон для фиксации активаторов из упаковки и снять ее с мастер-модели;")}</p>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/2.jpg")} effect="blur" alt="" />

      <p>
        {_t("- применить протокол холодной стерилизации;")} <br />
        {_t(
          "- примерить изделие в полости рта пациента на предмет плотного прилегания на все зубы соответствующей челюсти;",
        )}
        <br />
        {_t("- просушить изделие;")}
      </p>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/3.jpg")} effect="blur" alt="" />

      <p>
        {_t("- определить цвет зубов пациента;")} <br />
        {_t(
          "- подобрать и приготовить два типа фотополимеров для создания реставраций соответствующего цвета (густой композитный полимер и жидкотекучий);",
        )}{" "}
        <br />
        {_t("- подготовить зубы к фиксации активаторов в соответствии со стандартами протоколов;")} <br />
        {_t(
          "- в углубление в шаблоне, предназначенное для активатора, нанести густой композитный фотополимер на уровне с поверхностью зуба;",
        )}{" "}
        <br />
        {_t("- проконтролировать с наружной стороны изделия контуры будущего активатора;")}
      </p>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/4.jpg")} effect="blur" alt="" />

      <p>
        {_t(
          "- на сформированную поверхность композитного полимера с внутренней стороны шаблона нанести маленькую каплю жидкотекучего полимера и размазать по всей плоскости соединения материала с зубом;",
        )}{" "}
        <br />
        {_t("- надеть шаблон на зубы и плотно придавить до плотного прилегания всех плоскостей;")} <br />
        {_t(
          "- произвести засвечивание фотополимера в соответствии с техническими требованиями данного материала (количество зафиксированных за один раз активаторов может варьироваться в зависимости от опыта врача-стоматолога);",
        )}
      </p>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/5.jpg")} effect="blur" alt="" />

      <p>
        {_t("- извлечь шаблон из полости рта;")} <br />
        {_t("- убрать излишки композита вокруг активатора с использованием полировочных насадок;")} <br />
        {_t("- надеть элайнер № 1 и убедиться в ее плотном прилегании;")}
      </p>
      <LazyLoadImage src={require("../../assets/2_fixing-attachments/6.jpg")} effect="blur" alt="" />

      <p>
        {_t(
          "- убедиться в том, что пациент может самостоятельно надевать и снимать элайнер без использования дополнительных инструментов;",
        )}
      </p>
      <p>
        {_t(
          "В случаях, если элайнер не надевается после фиксации активаторов, или когда пациент не может самостоятельно снять его и извлечь из полости рта без дополнительных инструментов, необходимо произвести пришлифовку полировочными инструментами всех активаторов до улучшения процессов надевания и снимания элайнера пациентом.",
        )}
      </p>
      <h2>{_t("Дополнительный протокол:")}</h2>
      <p>
        {_t(
          "В случаях скола активаторов на разных этапах лечения элайнерами можно произвести повторную фиксацию активаторов с использованием «Шаблон для фиксации активаторов». Изменение положения зубов не является критическим фактором, делающим данное изделие не актуальным. Для этого необходимо выполнить следующие действия:",
        )}
      </p>
      <p>
        {_t(
          "- извлечь из упаковки Шаблон для фиксации активаторов, которая применялась для фиксации активаторов в начале ортодонтического лечения;",
        )}{" "}
        <br />
        {_t(
          "- с использованием скальпеля произвести сегментирование шаблона, а именно участка с зубом, на который будет фиксироваться активатор;",
        )}{" "}
        <br />
        {_t("- применить протокол холодной дезинфекции для фрагмента шаблона;")} <br />
        {_t("- примерить фрагмент шаблона в полости рта на соответствующем зубе.")}
      </p>
      <p>{_t("В случае если фрагмент шаблона не досаживается:")}</p>
      <p>
        {_t("- повторно произвести подрезание краёв фрагмента с использованием скальпеля;")} <br />
        {_t("- после плотной припасовки фрагмента изделия на зуб применить «Протокол фиксации активаторов» повторно.")}
      </p>
      <CustomReactPlayer
        src={require("../../assets/2_fixing-attachments/video_2.mp4")}
        poster={require("../../assets/2_fixing-attachments/video_2.jpg")}
      />
    </>
  );
};
